import ReactDOM from "react-dom";
import $ from "jquery";
import { removeNode } from "zeta-dom/domUtil";
import { extend } from "zeta-dom/util";

function Loading_() {
    return (
        <div className="eac-loading"></div>
    );
}

export const Loading = extend(Loading_, {
    block() {
        let container = $('<div class="eac-loading-full">').appendTo(document.body)[0];
        ReactDOM.render(<Loading />, container);
        return () => {
            removeNode(container);
        };
    }
});
